<template>
  <button class="btn bg-indigo-500 hover:bg-indigo-600 text-white p-2 rounded">{{ text }}</button>
</template>

<script>
export default {
  props: ["text"]
};
</script>

<style lang="scss" scoped></style>
